export const getCTAandWIAPIPositions = (
	viewportWidth,
	isGridLayout,
	positionPreference = 'false'
) => {
	const isTwoColumnGrid = viewportWidth < 1440 && isGridLayout;

	// index at which CTA and WIAPI cards are inserted into list of vehicles
	let firstPosition = 1; // list view case / smallscreen case

	// TEMPORARY, IF WE HAVE A POSITION PREFERENCE FROM HYUNDAI, WE NEED THE CARDS TO BE REPOSITIONED TO ACCOMODATE THEIR AD INSERTION
	if (positionPreference === 'true') {
		// index at which CTA and WIAPI cards are inserted into list of vehicles
		if (isTwoColumnGrid) {
			firstPosition = 1; // grid view with 2 columns case
		} else if (isGridLayout) {
			firstPosition = 2; // grid view with 3 columns case
		}
	} else if (positionPreference === 'false') {
		if (isTwoColumnGrid) {
			firstPosition = 2; // grid view with 2 columns case
		} else if (isGridLayout) {
			firstPosition = 3; // grid view with 3 columns case
		}
	}

	return [
		firstPosition,
		6,
		isTwoColumnGrid ? 10 : 9,
		isTwoColumnGrid ? 14 : 12
	];
};

/**
 * Method to calculate positions for cta or adcards based on num columns, size of inventory, and number of special cards allowed.
 * - First card will always be the last of the first row
 * - Last card will always be first in the second to last row
 * @param {number} invLength Length of vehicle inventory
 * @param {number} numCards Number of CTAs or Ads to get positions for
 * @param {number} columns Number of columns per row, also is the num VehicleCards per row
 * @returns {number[]} Array of positions that cards should be placed in with even distribution.
 */
export const getCtaAndAdCardPositions = (invLength, numCards = 3, columns) => {
	// get column nums from screen size
	const remainingCards = numCards - 2; // reduce by 2 for first and last card which always have a default position
	const positions = [];
	const first = columns - 1;
	positions.push(first);
	const offset = 1;
	let current = first + columns + offset;
	for (let i = 0; i < remainingCards; i++) {
		positions.push(current);
		current = current + columns + offset;
	}
	const last = invLength - (invLength % columns);
	positions.push(last);
	return positions;
};
